
// Cache for API keys fetched from backend
let cachedImageKeys: { UNSPLASH_ACCESS_KEY?: string; PEXELS_API_KEY?: string; PIXABAY_API_KEY?: string } | null = null;
let keysFetchPromise: Promise<typeof cachedImageKeys> | null = null;

// Hardcoded fallback keys (used when backend config is empty)
const FALLBACK_API_KEYS = {
    UNSPLASH_ACCESS_KEY: 'tSQoOF90Ap0roRMbfAq4iholZdyBbm8kRmAy0I-IuSc',
    PEXELS_API_KEY: 'KiH3M94y82QVD5wyqnoxzEjy4bHdxTi5FBHtZeAWusfXGjzGMWTn8Y40',
    PIXABAY_API_KEY: ''
};



// Fetch API keys from backend settings
const getImageApiKeys = async (): Promise<typeof cachedImageKeys> => {
    if (cachedImageKeys) return cachedImageKeys;

    // Prevent multiple simultaneous fetches
    if (keysFetchPromise) return keysFetchPromise;

    keysFetchPromise = (async () => {
        try {
            const res = await fetch('/api/settings/public/image-keys');
            const data = await res.json();
            if (data.success && data.keys) {
                // Use backend keys if provided, otherwise use fallbacks
                cachedImageKeys = {
                    UNSPLASH_ACCESS_KEY: data.keys.UNSPLASH_ACCESS_KEY || FALLBACK_API_KEYS.UNSPLASH_ACCESS_KEY,
                    PEXELS_API_KEY: data.keys.PEXELS_API_KEY || FALLBACK_API_KEYS.PEXELS_API_KEY,
                    PIXABAY_API_KEY: data.keys.PIXABAY_API_KEY || FALLBACK_API_KEYS.PIXABAY_API_KEY
                };
                return cachedImageKeys;
            }
        } catch (e) {
            console.warn('Failed to fetch image API keys from backend:', e);
        }
        // Fallback to hardcoded keys, then environment variables
        cachedImageKeys = {
            UNSPLASH_ACCESS_KEY: import.meta.env.VITE_UNSPLASH_ACCESS_KEY || FALLBACK_API_KEYS.UNSPLASH_ACCESS_KEY,
            PEXELS_API_KEY: import.meta.env.VITE_PEXELS_API_KEY || FALLBACK_API_KEYS.PEXELS_API_KEY,
            PIXABAY_API_KEY: import.meta.env.VITE_PIXABAY_API_KEY || FALLBACK_API_KEYS.PIXABAY_API_KEY
        };
        return cachedImageKeys;
    })();

    return keysFetchPromise;
};


// Fallback images if API fails
const FALLBACK_IMAGES: Record<string, string> = {
    'default': 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=1200',
    'beach': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1200',
    'city': 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?q=80&w=1200',
    'mountain': 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=1200'
};

export const fetchDestinationImage = async (query: string): Promise<string> => {
    // DISABLED: Stock photo APIs are not used per user request
    // Hotels and destinations should only show images from Tourvisio API or admin panel

    // Return empty string - components should handle missing images gracefully
    return '';
};

export const getRandomImageForTerm = fetchDestinationImage;

export const getRandomTravelImage = async (): Promise<string> => {
    return fetchDestinationImage('luxury travel destination');
}

export const getImagesForDestination = async (query: string, count: number = 1): Promise<string[]> => {
    // DISABLED: Stock photo APIs are not used per user request
    // Hotels and destinations should only show images from Tourvisio API or admin panel
    return [];
};
